/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Hero_Compare_LinkInputs */

const en_why_listening_hero_compare_link = /** @type {(inputs: Why_Listening_Hero_Compare_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how Listening compares`)
};

const es_why_listening_hero_compare_link = /** @type {(inputs: Why_Listening_Hero_Compare_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mira cómo se compara Listening`)
};

/**
* | output |
* | --- |
* | "See how Listening compares" |
*
* @param {Why_Listening_Hero_Compare_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_hero_compare_link = /** @type {((inputs?: Why_Listening_Hero_Compare_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Hero_Compare_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_hero_compare_link(inputs)
	return en_why_listening_hero_compare_link(inputs)
});